import React from "react";
import * as moment from "moment";

import styles from "./PublishDate.scss";

const PublishDate = props => {
  const { date, lang, className = "" } = props;
  let _dateFormat;
  switch (lang.toLowerCase()) {
    case "fr":
      _dateFormat = "ddd ll";
      break;
    case "es":
      _dateFormat = "ddd ll";
      break;
    default:
      _dateFormat = "ddd, ll";
  }

  return (
    <time
      className={`news__pubDate ${styles.pubDate} ${className}`}
      pubdate="pubdate"
    >
      {moment(date).format(_dateFormat)}
    </time>
  );
};

export default PublishDate;
